var _style, _path, _path2, _path3, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdAustriaLogoNoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1800 560",
    style: {
      enableBackground: "new 0 0 1800 560"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n\t.st1{fill:none;}\n\t.st2{fill:#5F7A8E;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#E6320F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M628.7,234.5c-5.5-5.5-12.4-8.2-20.8-8.2c-8.4,0-15.4,2.9-21.2,8.6c-5.8,5.8-8.6,12.6-8.6,20.4 c0,7.8,3,14.8,9,20.8c6,6,12.9,9,20.8,9s14.6-2.9,20.4-8.6c5.8-5.8,8.6-12.8,8.6-21.2C636.9,246.9,634.1,240,628.7,234.5z  M713.8,208.2c-0.3-16-6-29.5-16.9-40.4c-11.2-11.2-25.2-16.9-42-16.9H498.8c-4.2,0-8.2,1-12.2,3.1c-3.9,2.1-6.9,5-9,8.6L453.3,205 h-77.7v35.3h83.9c4.2,0,8.2-1,12.2-3.1c3.9-2.1,6.9-5,9-8.6l24.3-42.4h143.6c8.4,0,15.4,2.9,21.2,8.6c5.8,5.8,8.6,12.8,8.6,21.2 v124.7c0,8.4-2.9,15.4-8.6,21.2c-5.8,5.8-12.8,8.6-21.2,8.6H505.9L462.7,296c-2.1-3.6-5.1-6.5-9-8.6c-3.9-2.1-8-3.1-12.2-3.1h-65.9 v35.3h59.6l42.4,73.7c2.1,3.7,5.1,6.7,9,9c3.9,2.3,8,3.5,12.2,3.5H655c16.7,0,30.7-5.6,42-16.9c10.9-10.9,16.5-24.3,16.9-40.4 c0-0.5,0-1,0-1.6V209.8C713.8,209.2,713.8,208.7,713.8,208.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M607.9,285.1c-7.8,0-14.8-3-20.8-9c-6-6-9-12.9-9-20.8c0-7.8,2.9-14.6,8.6-20.4c5.8-5.7,12.8-8.6,21.2-8.6 c8.4,0,15.3,2.8,20.8,8.2c5.5,5.5,8.2,12.4,8.2,20.8c0,8.4-2.9,15.4-8.6,21.2C622.5,282.2,615.7,285.1,607.9,285.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.715,
    y1: 405.86,
    x2: 544.715,
    y2: 150.92
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8BA3BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#466272"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M713.8,208.2v140.4c-0.3,16.1-6,29.5-16.9,40.4c-11.2,11.2-25.2,16.9-42,16.9H498.8c-4.2,0-8.2-1.2-12.2-3.5 c-3.9-2.4-6.9-5.4-9-9l-42.4-73.7h-59.6v-35.3h65.9c4.2,0,8.2,1.1,12.2,3.1c3.9,2.1,6.9,5,9,8.6l43.2,74.5h142.8 c8.4,0,15.4-2.9,21.2-8.6c5.8-5.8,8.6-12.8,8.6-21.2V216c0-8.4-2.9-15.4-8.6-21.2c-5.8-5.8-12.8-8.6-21.2-8.6H505.1l-24.3,42.4 c-2.1,3.7-5.1,6.5-9,8.6c-3.9,2.1-8,3.1-12.2,3.1h-83.9V205h77.7l24.3-42.4c2.1-3.7,5.1-6.5,9-8.6c3.9-2.1,8-3.1,12.2-3.1H655 c16.7,0,30.7,5.6,42,16.9C707.8,178.7,713.4,192.2,713.8,208.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "160.7,203.5 179.5,242.7 336.4,242.7 336.4,203.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "336.4,321.1 336.4,281.9 198.4,281.9 217.2,321.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdAustriaLogoNoText);
export default __webpack_public_path__ + "static/media/IDAustriaLogoNoText.85a7c4a0b0eb9d450fab5819729564cc.svg";
export { ForwardRef as ReactComponent };